import PageHeader from '../components/PageHeader.jsx';
import '../styles/fonts.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import Sidebar from '../components/Sidebar.jsx';


const Notebook = () => {
    let sampleImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
    let labnotes1 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes1.png';
    let labnotes3 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes3.png';
    let labnotes4 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes4.png';
    let labnotes5 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes5.png';
    let labnotes7 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes7.png';
    let labnotes8 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes8n.png';
    let labnotes10 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes10.png';
    let labnotes11 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes11.png';
    let labnotes13 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes13.png';
    let labnotes14 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes14.png';
    let labnotes15 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes15.png';
    let labnotes16 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes16.png';
    let labnotes18 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes18.png';
    let labnotes20 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes20.png';
    let labnotes21 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes21.png';
    let labnotes26 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes26.png';
    let labnotes28 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes28.png';
    let labnotes29 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes29.png';
    let labnotes30 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes30.png';
    let labnotes32 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes32.png';
    let labnotes33 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes33.png';
    let labnotes34 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes34.png';
	let labnotes48 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes48.png';
	let labnotes49 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes49.png';
    let labnotes50 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes50.png';
	let labnotes51 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes51.png';
	let labnotes52 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes52.png';
	let labnotes53 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes53n.png';
	let labnotes54 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes54.png';
	let labnotes55 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes55.png';
	let labnotes56 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes56n.png';
	let labnotes57 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes57n.png';
	let labnotes58 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes58.png';
	let labnotes59 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes59.png';
	let labnotes60 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes60.png';
	let labnotes61 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes61n.png';
	let labnotes63 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes63.png';
	let labnotes64 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes64.png';
	let labnotes65 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes65.png';
	let labnotes66 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes66.png';
	let labnotes67 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes67.png';
	let labnotes68 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes68.png';
	let labnotes69 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes69.png';
	let labnotes70 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes70.png';
	let labnotes71 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes71.png';
	let labnotes72 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes72.png';
	let labnotes73 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes73.png';
	let labnotes74 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes74.png';
	let labnotes75 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes75.png';
	let labnotes76 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes76.png';
	let labnotes77 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes77.png';
	let labnotes78 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes78.png';
	let labnotes79 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes79.png';
	let labnotes80 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes118.png';
	let labnotes81 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes81.png';
	let labnotes82 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes82.png';
	let labnotes83 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes83.png';
	let labnotes84 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes84.png';
	let labnotes85 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes85.png';
	let labnotes86 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes86.png';
	let labnotes87 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes87.png';
	let labnotes88 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes88.png';
	let labnotes89 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes89.png';
	let labnotes90 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes90.png';
	let labnotes91 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes91.png';
	let labnotes92 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes92.png';
	let labnotes93 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes93.png';
	let labnotes94 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes94.png';
	let labnotes95 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes95.png';
	let labnotes96 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes96.png';
	let labnotes97 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes97.png';
	let labnotes98 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes98.png';
	let labnotes99 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes99.png';
	let labnotes100 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes100.png';
	let labnotes101 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes101.png';
	let labnotes102 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes102.png';
	let labnotes103 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes103.png';
	let labnotes104 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes104.png';
	let labnotes105 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes105.png';
	let labnotes106 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes106.png';
	let labnotes107 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes107.png';
	let labnotes108 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes108.png';
	let labnotes109 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes109.png';
	let labnotes110 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes110.png';
	let labnotes111 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes111.png';
	let labnotes112 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes112.png';
	let labnotes113 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes113.png';
	let labnotes114 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes114.png';
	let labnotes115 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes115.png';
	let labnotes116 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes116.png';
	let labnotes117 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes117.png';
	let labnotes119 = 'https://static.igem.wiki/teams/5066/wetlab/labnotes119.png';

    let sections =[
        {id:'s1', name:'June'},
		{id:'s2', name:'July'},
		{id:'s3', name:'August'},
		{id:'s4', name:'September'},

    ]
    return (
        
    <div>
        
        <PageHeader img={sampleImg} title={'Notebook'} />
        {/* Main Content */}
        <div className='flex'>
        <Sidebar sections={sections} />

            <div className='flex-col w-full lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-white shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>
            <section id='s1'>
						<div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
							<span className='text-gray-800 font-bold'></span>
						</div>
						<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							June
						</h2>	
						<p className='text-xl mt-6 mb-2 font-bold'> 
						2024 June 1st (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> Cyt2Ba fragment and BBa_K4955002_k4955002 fragment

						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
						•	Restriction enzyme digestion of pET28a
						</a>
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: 
							</a>
							Cyt2Ba fragment PCR, BBa_K4955002_k4955002 fragment PCR and digested pET28a
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	Ran the 1st electrophoresis for 40min and undigested & digested pET28a showed bands but inserts did not 
						</p>
						<img
							src={labnotes1}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5 mb-2'>
							-	 Run electrophoresis of inserts at 30min instead of 40min
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						<p className='text-lg ml-5'>
						Katie Lu
						</p>
						<p className='text-lg ml-5'>
						Morris Yang
						</p>
						<p className='text-lg ml-5'>
						Max Lee
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 2nd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-isolation-using-viogene-gel-pcr-isolation-system-cat-no-gp1002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel Isolation using Viogene Gel/PCR Isolation System (Cat No. GP1002):
							</a>
							digested pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a
							</a>
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-viogene-gel-pcr-isolation-system-cat-no-gp1002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation for PCR amplified inserts using Viogene Gel/PCR Isolation System (Cat No. GP1002)
							</a>
							(from June 1st): BBa_K4955002 3, Cyt2Ba 1, Cyt2Ba 2
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR:
							</a>
							BBa_K4955002 fragment
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: 
							</a>
							digested pET28a, BBa_K4955002 fragment PCR

						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	Gel isolation and PCR isolation came back with small concentrations
						</p>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-10 py-1">Gel Isolation 6/2</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-10 py-1">Sample</th>
                                            <th className="border border-gray-300 text-center px-10 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">2</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">2</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">PCR Isolation 6/2</th>
											<th className="border border-transparent px-10 py-1"></th>
											<th className="border border-transparent px-10 py-1"></th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-16 py-1">Sample</th>
                                            <th className="border border-gray-300 text-center px-1 py-1">Overlap extention PCR temperature (°C) </th>
											<th className="border border-gray-300 text-center px-10 py-1">Concentration trial 1 (ng/μl) </th>
											<th className="border border-gray-300 text-center px-10 py-1">Concentration trial 2 (ng/μl) </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Ch3</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">70</td>
											<td className="border border-gray-300 text-center px-2 py-1 ">24</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">42</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cy1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">68</td>
											<td className="border border-gray-300 text-center px-2 py-1">4</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">2</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cy2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">69</td>
											<td className="border border-gray-300 text-center px-2 py-1">5</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">n/a</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg ml-5'>
							-	Gel electrophoresis of overlap extension PCR BBa_K4955002 samples came back with consistent but faint bands
						</p>
						<img
							src={labnotes3}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<img
							src={labnotes4}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5 mb-2'>
							-	Not enough pET28a, will need to order more
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Morris Yang
						</p>
						<p className='text-lg ml-5'>
						Katie Lu
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 8th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: 
							</a>
							Cyt2Ba fragment and BBa_K4955002 fragment
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: 
							</a> 
							Cyt2Ba fragment PCR and BBa_K4955002  fragment PCR
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-viogene-gel-pcr-isolation-system-cat-no-gp1002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation for PCR amplified inserts using Viogene Gel/PCR Isolation System (Cat No. GP1002)
							</a>
							(from June 2nd): BBa_K4955002
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-10 py-1">Overlap extention PCR 6/8</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-20 py-1">Sample</th>
                                            <th className="border border-gray-300 text-center px-10 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cy1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">321</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cy2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">410</td>
										</tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cy3</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">613</td>
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cy4</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">592</td>    
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Ch1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">457</td>    
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Ch2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">465</td>    
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Ch3</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">457</td>    
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<img
							src={labnotes5}
							alt='softwarePic'
							className='w-full h-auto'
						/>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						<p className='text-lg ml-5'>
						Katie Lu
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 9th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/plasmid-dna-extraction-using-viogene-mini-plus-plasmid-dna-extraction-system-cat-no-gf2002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Plasmid DNA Extraction using Viogene Mini Plus Plasmid DNA Extraction System (Cat No. GF2002): </a> pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a </a>
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> of digested pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-isolation-using-viogene-gel-pcr-isolation-system-cat-no-gp1002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel Isolation using Viogene Gel/PCR Isolation System (Cat No. GP1002): </a> digested pET28a
						</p>
						
						<p className='text-lg font-bold'>
							Results
						</p>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">Plasmid DNA extraction 6/9</th>
											<th className="border border-transparent px-10 py-1"></th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-10 py-1">Sample</th>
                                            <th className="border border-gray-300 text-center px-10 py-1">Which liquid culture tube used</th>
											<th className="border border-gray-300 text-center px-10 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">1</td>
											<td className="border border-gray-300 text-center px-2 py-1">40</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">1</td>
											<td className="border border-gray-300 text-center px-2 py-1">47</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #3</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">1</td>
											<td className="border border-gray-300 text-center px-2 py-1">45</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #4</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">2</td>
											<td className="border border-gray-300 text-center px-2 py-1">40</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #5</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">3</td>
											<td className="border border-gray-300 text-center px-2 py-1">44</td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
							
						<img
							src={labnotes7}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-4 py-1">Gel Isolation 6/9</th>
											<th className="border border-transparent px-10 py-1"></th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-8 py-1">Sample</th>
                                            <th className="border border-gray-300 text-center px-4 py-1">Wells used</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">3 & 4</td>
											<td className="border border-gray-300 text-center px-2 py-1">6</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">5</td>
											<td className="border border-gray-300 text-center px-2 py-1">6</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">3</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">7</td>
											<td className="border border-gray-300 text-center px-2 py-1">14</td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Katie Lu
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
												
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 15th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> Cyt2Ba fragment, BBa_K4955002 fragment, Xpp81Aa1 fragment
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA Assembly: </a> pET28a + Cyt2Ba and pET28a + BBa_K4955002
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a>  Xpp81Aa1 fragment PCR
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a>  Cyt2Ba, BBa_K4955002, pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/plasmid-dna-extraction-using-viogene-mini-plus-plasmid-dna-extraction-system-cat-no-gf2002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Plasmid DNA Extraction using Viogene Mini Plus Plasmid DNA Extraction System (Cat No. GF2002): </a> pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a> pET28a with Cyt2Ba insert into DH5α cells
						</p>
						
						<p className='text-lg font-bold'>
							Results
						</p>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">Overlap extention PCR 6/15</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-2 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cyt2ba</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">459</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">BBa_K4955002</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">504</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Xpp81Aa1 #1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">480</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Xpp81Aa1 #1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">479</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Xpp81Aa1 #1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">475</td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">PCR Isolation 6/15</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-8 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">BBa_K4955002 #1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">25</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">BBa_K4955002 #2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">42</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cyt2Ba #1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">21</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cyt2Ba #2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">24</td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
						<img
							src={labnotes8}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg ml-5'>
							-	Transformation of pET28a and Cyt2Ba  failed, no colonies were present
						</p>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">PCR isolation new vs old kit 6/15</th>
											<th className="border border-transparent px-10 py-1"></th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-20 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration old kit (ng/μl)</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration new kit (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">45</td>
											<td className="border border-gray-300 text-center px-2 py-1">11</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Myron Yu
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Katie Lu
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
												
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 16th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a </a>
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> digested pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-isolation-using-qiaquick-gel-extraction-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel Isolation using QIAquick gel extraction kit: </a>  digested pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA Assembly: </a> pET28a + Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a> pET28a with Cyt2Ba insert into DH5α cells
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture for plasmid extraction: </a> 12 pET28a colonies 
						</p>
						<img
							src={labnotes10}
							alt='softwarePic'
							className='w-2/3 h-auto'
						/>
						
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes11}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">Gel isolation 6/16</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-8 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">4</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						<p className='text-lg ml-5'>
						Max Lee
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						
																		
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 17th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/plasmid-dna-extraction-using-viogene-mini-plus-plasmid-dna-extraction-system-cat-no-gf2002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Plasmid DNA Extraction using Viogene Mini Plus Plasmid DNA Extraction System (Cat No. GF2002) </a> (from June 16th): pET28a
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<div className="container p-2 w-3/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">Plasmid DNA extraction 6/17</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-8 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">114</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">84</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 3</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">141</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 4</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">158</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 5</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">163</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 6</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">136</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 7</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">125</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 8</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">104</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 9</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">166</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 10</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">122</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 11</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">136</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a 12</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">134</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 18th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a: </a>  12 pET28a samples
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Digested pET28a
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes13}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 20th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a> pET28a with Cyt2Ba insert into DH5α cells
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Digested pET28a
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	Transformation yielded 1 colony 
						</p>
						<img
							src={labnotes14}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 22nd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a </a>
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Digested pET28a,  DH5α-pET28a-Cyt2Ba colony PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA Assembly: </a>  pET28a + Xpp81Aa1
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture for plasmid extraction: </a> pET28a, Cyt2Ba in DH5α cells (for plasmid extraction)
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes15}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5'>
						-	30-minute assembly yielded 74 colonies, while the 15-minute assembly yielded less than 20 colonies
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						<p className='text-lg ml-5'>
						Max Lee
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
												
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 23rd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA Assembly: </a> pET28a + BBa_K4955002
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> Xpp81Aa1
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Digested pET28a, Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a> pET28a
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a>  pET28a-Xpp81Aa1 into DH5α cells, pET28a-Cyt2Ba into DH5α cells
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							- Transformation: 
						</p>
						<p className='text-lg ml-10'>
							- Assembly Incubation 15 mins
						</p>
						<p className='text-lg ml-16'>
							-	pET28a + Xpp81Aa1 - 15 colonies
						</p>
						<p className='text-lg ml-16'>
							-	pET28a + Cyt2Ba - 10 colonies
						</p>
						<p className='text-lg ml-10'>
							-	Assembly Incubation 30 mins
						</p>
						<p className='text-lg ml-16'>
							-	pET28a + Xpp81Aa1 - 74 colonies
						</p>
						<p className='text-lg ml-16'>
							-	pET28a + Cyt2Ba - 5 colonies
						</p>
						<p className='text-lg ml-5'>
							-	PCR Isolation
						</p>
						<div className="container p-2 w-1/3">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-8 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Digested pET28a</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">12</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>
						<img
							src={labnotes16}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Max Lee
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
												
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 24th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR </a> - DH5α-pET28a-Cyt2Ba, DH5α-pET28a-BBa_K4955002
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis </a> - Xpp81Aa1 x3
						</p>
					
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes18}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg ml-5'>
						-	The other two gel electrophoresis samples showed no bands
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Myron Yu
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 25th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis </a> -  DH5α-pET28a-Xpp81Aa1 colony PCR, DH5α-pET28a-Cyt2Ba colony PCR, DH5α-pET28a-BBa_K4955002 colony PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture  </a> DH5α-pET28a-Xpp81Aa1, DH5α-pET28a-Cyt2Ba, BBa_K4955002 (DH5α cells)
						</p>
					
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes48}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5'>
						-	Ran BBa_K4955002 colony for 15 minutes then another at 30 minutes, both showed no bands
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Myron Yu
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 26th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> BBa_K4955002
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a> Cyt2Ba, Xpp81Aa1
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a>  BBa_K4955002 colony PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture: </a> BBa_K4955002 (DH5α cells), Xpp81Aa1 (DH5α cells)
						</p>
					
						<p className='text-lg font-bold'>
							Results
						</p>
						<div className="container p-2 w-2/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">PCR Isolation 6/26</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-14 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a-Xpp81Aa1 #1</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">0.9</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a-Xpp81Aa1 #2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">0.8</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a-Xpp81Aa1 #3</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">0.7</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>

						<img
							src={labnotes20}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<img
							src={labnotes21}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Florence Wu
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 27th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture: </a> DH5α-pET28a-Cyt2Ba, DH5α-pET28a-Xpp81Aa1 
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a> Xpp81Aa1 
						</p>
					
						<p className='text-lg font-bold'>
							Results
						</p>
						<div className="container p-2 w-2/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">PCR Isolation 6/27 30 mins</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-20 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a-Xpp81Aa1 #16</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">83</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a-Xpp81Aa1 #17</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">0.8</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>
						
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 28th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a> Xpp81Aa1
						</p>
					
						<p className='text-lg font-bold'>
							Results
						</p>
						
						<div className="container p-2 w-2/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">PCR Isolation 6/28 30 mins</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-20 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a-Xpp81Aa1 #16</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">104</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a-Xpp81Aa1 #17</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">37</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5'>
							#16 sent to sequencing
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						<p className='text-lg ml-5'>
						Florence Wu
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 29th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> BmK IT1 fragment, Cry2Aa fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a> pET28a
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a> pET28a-Cyt2Ba into DH5α cells
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> BmK IT1 fragment PCR, Cry2Aa fragment PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a> pET28a-Xpp81Aa1 into BL21 cells
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
					
						<div className="container p-2 w-2/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">pET28a PCR Isolation 6/29</th>
											<th className="border border-transparent px-10 py-1"></th>
											<th className="border border-transparent px-10 py-1"></th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-20 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
											<th className="border border-gray-300 text-center px-8 py-1">A230</th>
											<th className="border border-gray-300 text-center px-8 py-1">280</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #1</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">8</td>
											<td className="border border-gray-300 text-center px-2 py-1">0.01</td>
											<td className="border border-gray-300 text-center px-2 py-1">2.66</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #1</td>
                                            <td className="border border-bottom-transparent text-center px-2 py-1">7</td>
											<td className="border border-gray-300 text-center px-2 py-1">0.014</td>
											<td className="border border-gray-300 text-center px-2 py-1">2.38</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #2</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">13</td>
											<td className="border border-gray-300 text-center px-2 py-1">0.011</td>
											<td className="border border-gray-300 text-center px-2 py-1">2.16</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #3</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">5</td>
											<td className="border border-gray-300 text-center px-2 py-1">0.012</td>
											<td className="border border-gray-300 text-center px-2 py-1">2.5</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #4</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">5</td>
											<td className="border border-gray-300 text-center px-2 py-1">0.01</td>
											<td className="border border-gray-300 text-center px-2 py-1">2.5</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a #5</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">15</td>
											<td className="border border-gray-300 text-center px-2 py-1">0.016</td>
											<td className="border border-gray-300 text-center px-2 py-1">2.14</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-2/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
								<thead className=''>
                                        <tr>
                                            <th className="border border-gray-300 px-2 py-1">Overlap Extension PCR 6/29</th>
											<th className="border border-transparent px-10 py-1"></th>
                                        </tr>
                                    </thead>
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-20 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">BmK</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">565</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">BmK</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">577</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cry2Aa</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">679</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">Cry2Aa</td>
                                            <td className="border border-gray-300 text-center px-2 py-1">699</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg ml-5'>
						-	Electrophoresis of the first electrophoresis showed no bands
						</p>
						<img
							src={labnotes26}
							alt='softwarePic'
							className='w-3/5 h-auto'
						/>
						
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5'>
						•	Overlap Extension PCR - run gradient program
						</p>
					
						<div class="overflow-x-auto">
							<table class="table-auto border-collapse border-gray-700">
								<tbody>
								<tr>
									<td class="border border-gray-300 px-10 py-2">98°C</td>
									<td class="border border-gray-300 px-10 py-2">2 min</td>
									<td class="border border-gray-300 px-10 py-2">Step 1</td>
									<td class="border border-gray-300 px-10 py-2">1 cycle</td>
								</tr>
								<tr>
									<td class="border border-gray-300 px-10 py-2">98°C</td>
									<td class="border border-gray-300 px-10 py-2">10 sec</td>
									<td class="border border-gray-300 border-b-0 px-10 py-2"></td>
									<td class="border border-gray-300 border-b-0 px-10 py-2"></td>
								</tr>
								<tr>
									<td class="border border-gray-300 px-10 py-2">68-70°C</td>
									<td class="border border-gray-300 px-10 py-2">30 sec</td>
									<td class="border border-gray-300 border-t-0 border-b-0 px-10 py-2">Step 2</td>
									<td class="border border-gray-300 border-t-0 border-b-0 px-10 py-2">30 cycles</td>
								</tr>
								<tr>
									<td class="border border-gray-300 px-10 py-2">72°C</td>
									<td class="border border-gray-300 px-10 py-2">30 sec</td>
									<td class="border border-gray-300 border-t-0 px-10 py-2"></td>
									<td class="border border-gray-300 border-t-0 px-10 py-2"></td>
								</tr>
								<tr>
									<td class="border border-gray-300 px-10 py-2">72°C</td>
									<td class="border border-gray-300 px-10 py-2">10 min</td>
									<td class="border border-gray-300 border-b-0 px-10 py-2">Step 3</td>
									<td class="border border-gray-300 border-b-0 px-10 py-2">1 cycle</td>
								</tr>
								<tr>
									<td class="border border-gray-300 px-10 py-2">4°C</td>
									<td class="border border-gray-300 px-10 py-2">∞</td>
									<td class="border border-gray-300 border-t-0 px-10 py-2"></td>
									<td class="border border-gray-300  border-t-0 px-10 py-2"></td>
								</tr>
								</tbody>
							</table>
							</div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Max Lee
						</p>
						<p className='text-lg ml-5'>
						Florence Wu
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 June 30th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> Cry2Aa fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Cry2Aa fragment PCR, BmK IT1 fragment PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA Assembly: </a>  pET28a + Cyt2Ba and pET28a + BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a>  pET28a-Cyt2Ba, pET28a-BmK IT1 into DH5α cells
						</p>
						
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes28}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<img
							src={labnotes29}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5'>
						BmK IT1 PCR Amplification: Clear band, however, the ladder was not visible. Moving on to DNA assembly and transformation into DH5ɑ.

						</p>
						<p className='text-lg mt-2 mb-2 ml-5'>
						Vip3Aa PCR Amplification: Clear band, and correct position. Moving on to DNA assembly and transformation into DH5ɑ.
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>

						</section>

						 <section id='s2'>
						<div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
							<span className='text-gray-800 font-bold'></span>
						</div>
						<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							July
						</h2>	
						

						<p className='text-xl mt-6 mb-2 font-bold'> 
						2024 July 1st (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-BmK, DH5α-pET28a-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid Bacterial Culture: </a> DH5α-pET28a
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
						
							
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 2nd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-BmK, DH5α-pET28a-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> Xpp81Aa1 fragment, Cry2Aa fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> DH5α-pET28a-BmK IT1 colony PCR, DH5α-pET28a-Cyt2Ba colony PCR, Xpp81Aa1 fragment PCR, Cry2Aa fragment PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a> pET28a
						</p>
						
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes30}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<div className="container p-2 w-2/5">
                                {/* Table for BL21-Cyt2ba #2 */}
                                <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-100'>
                                        <tr>
                                            <th className="border border-gray-300 text-center px-20 py-1">Sample</th>
											<th className="border border-gray-300 text-center px-2 py-1">Concentration (ng/μl)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a- #13</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">70</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a- #14</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">77</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a- #15</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">55</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a- #16</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">63</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 text-center px-2 py-1 bg-gray-100">pET28a- #17</td>
                                            <td className="border border-gray-300 text-center px-20 py-1">61</td>
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>
						<img
							src={labnotes32}
							alt='softwarePic'
							className='w-2/3 h-auto'
						/>
						<img
							src={labnotes33}
							alt='softwarePic'
							className='w-2/3 h-auto'
						/>

						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Florence Wu
						</p>
						<p className='text-lg ml-5'>
						Morris Yang
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 3rd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-BmK, DH5α-pET28a-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	PCR isolation using QIAquick PCR purification kit: </a> Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> DH5α-pET28a-BmK IT1 colony PCR, DH5α-pET28a-Cyt2Ba colony PCR
						</p>

						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes34}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 4th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR </a>  DH5α-pET28a-BmK, DH5α-pET28a-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> DH5α-pET28a-BmK IT1 colony PCR, DH5α-pET28a-Cyt2Ba colony PCR
						</p>

						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	The gel electrophoresis ladder did not show
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 5th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA assembly:</a> pET28a + Xpp81Aa1, pET28a + Cyt2Ba
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
												
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 6th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> BmK IT1 fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> BmK IT1 fragment PCR, DH5α-pET28a-Xpp81Aa1 colony PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-Xpp81Aa1, DH5α-pET28a-BmK IT1   
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
                            src={labnotes97}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<img
                            src={labnotes98}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<img
                            src={labnotes99}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />

						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting 
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng 
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
						<p className='text-lg ml-5'>
						Chelsea Lin 
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
																		
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 7th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a>  DH5α-pET28a-Xpp81Aa1 colony PCR 
						</p>

						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	Both gels showed no bands
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting 
						</p>
						<p className='text-lg ml-5'>
						Chelsea Lin 
						</p>
																						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 9th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA assembly: </a>  pET28a + Xpp81Aa1
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
																												
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 10th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial Dilution and plating: </a> BL21-pET28a-Cyt2Ba Clone#1 #2 #3
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Xpp81Aa1
						</p>

						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes49}
							alt='softwarePic'
							className='w-3/5 h-auto ml-5'
						/>
						 <div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/10/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #1</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">4</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">54</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">5.4E+06</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<img
							src={labnotes50}
							alt='softwarePic'
							className='w-3/5 h-auto ml-5'
						/>
						 <div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/10/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #2</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">5</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">24</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">2.4E+07</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<img
							src={labnotes51}
							alt='softwarePic'
							className='w-3/5 h-auto ml-5'
						/>
						 <div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/10/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #3</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">5</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">27</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">2.7E+07</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
																											
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 11th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> BmK IT1 fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> BmK IT1 fragment PCR 
						</p>

						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	The gel results were smeared.
 
						</p>

						<p className='text-lg font-bold'>
							Notes
						</p>
						
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <tbody>
									<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Temperature</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">Time</td>
											<td className="border border-gray-300 px-2 border-b-0 text-right py-1"></td>
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 ">98°C</td>
                                            <td className="border border-gray-300 px-2 py-1">10 sec</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1">70°C</td>
                                            <td className="border border-gray-300 px-2 py-1">30 sec</td>
											
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1">72°C</td>
                                            <td className="border border-gray-300 px-2 py-1">1 min</td>
											<td className="border border-gray-300 border-t-0 px-2 py-1">repeat 30 cycles</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Chelsea Lin 
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Audrey Fang
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
																															
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 12th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-BmK, DH5α-pET28a-Xpp81Aa1
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Max Lee
						</p>
																																					
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 13th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-Xpp81Aa1
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> BmK IT1 fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> DH5α-pET28a-Xpp81Aa1 colony PCR
						</p>

						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	Gel showed no bands
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Audrey Fang
						</p>
																																								
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 14th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-Xpp81Aa1 (twice)
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a>  Xpp81Aa1 fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a>  pET28a-Xpp81Aa1 into DH5α cells
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA assembly: </a> pET28a + BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Xpp81Aa1 fragment PCR
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
						<p className='text-lg ml-5'>
						Max Lee
						</p>
						
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 15th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a>  DH5α-pET28a-BmK IT1  
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Audrey Fang
						</p>
						<p className='text-lg ml-5'>
						Myron Yu
						</p>
						<p className='text-lg ml-5'>
						Florence Wu
						</p>
								
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 16th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating: </a>  BL21-pET28a-Cyt2Ba #1 #2
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes52}
							alt='softwarePic'
							className='w-3/5 ml-5 h-auto'
						/>
						
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/16/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #1</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">3</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">1.0E+06</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/16/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #2</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">4</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">124</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">1.24E+07</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Morris Yang 
						</p>
										
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 17th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a>  Xpp81Aa1 fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Xpp81Aa1 fragment PCR  
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
							-	The gel showed no bands  
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 18th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap Extension PCR: </a> Cry2Aa fragment, Xpp81Aa fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	 Serial dilution and plating: </a> BL21-pET28a-Cyt2Ba #2
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes53}
							alt='softwarePic'
							className='w-3/5 ml-5 h-auto'
						/>
						
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/18/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #2</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">4</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">69</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">6.90E+06</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 19th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating: </a> BL21-pET28a-Cyt2Ba #3
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes54}
							alt='softwarePic'
							className='w-3/5 ml-5 h-auto'
						/>
												<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/19/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #3</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">4</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">60</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">6.00E+06</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
								
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 20th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	SDS-PAGE </a>
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> digest pET28a 
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution: </a> BL21-pET28a-Cyt2Ba #1
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes55}
							alt='softwarePic'
							className='w-3/5 ml-5 h-auto'
						/>
					<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/20/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #1</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">4</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">128</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">1.28E+07</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
								
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 21st (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> pET28a
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	SDS-PAGE: </a> BL21-pET28a-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA assembly: </a> pET28a + BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a>  pET28a-BmK IT1 into DH5α cells
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 22nd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating: </a> BL21-pET28a-Cyt2Ba #3, BL21-empty
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pellet-collection-1.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
						•	Dry Pellets Collection </a>
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> DH5α-pET28a-BmK IT1 colony PCR
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>	
						<img
							src={labnotes56}
							alt='softwarePic'
							className='w-3/5 ml-5 h-auto'
						/>		

							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/22/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #3</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">5</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">43</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">4.30E+0</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>	
							<img
							src={labnotes57}
							alt='softwarePic'
							className='w-3/5 ml-5 h-auto'
						/>		

							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">7/22/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-empty</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">79</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">7.90E+08</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>	
							<img
							src={labnotes58}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>	
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 23rd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a> Xpp81Aa1fragment, Cry2Aa fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Xpp81Aa1 fragment PCR, Cry2Aa fragment PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA assembly: </a>  pET28a + Xpp81Aa1
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a> pET28a-Xpp81Aa1 into DH5α cells 
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
							src={labnotes59}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg ml-5'>
						-	Cry2Aa fragment PCR gel electrophoresis showed no bands
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen

						</p>
						<p className='text-lg ml-5'>
						Morris Yang
						</p>
					
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 26th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> DH5α-pET28a-Xpp81Aa1
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/qiaprep-spin-miniprep-kit-dna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA Extraction: </a> pET28a-BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Xpp81Aa1 colony PCR
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>	
						
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">DNA Extraction 7/26</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Concentration</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-BmK IT1 #1</td>
                                            <td className="border border-gray-300 px-2 py-1">54 ng/μL</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-BmK IT1 #2</td>
                                            <td className="border border-gray-300 px-2 py-1">47 ng/μL</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-BmK IT1 #7</td>
                                            <td className="border border-gray-300 px-2 py-1">43ng/μL</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-BmK IT1 #8</td>
                                            <td className="border border-gray-300 px-2 py-1">28 ng/μL</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-BmK IT1 #5</td>
                                            <td className="border border-gray-300 px-2 py-1">72 ng/μL</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<img
							src={labnotes60}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>


						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						<p className='text-lg ml-5'>
						Dora Shen
						</p>
						<p className='text-lg ml-5'>
						Abby Hung

						</p>
						<p className='text-lg ml-5'>
						Abner Tseng
						</p>
							
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 27th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	SDS-PAGE </a> 
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a>  pET28a-BmK IT1 into BL21 cells
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a>  BL21-pET28a-BmK IT1 colony PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid Bacterial Culture: </a>  BL21-pET28a-Xpp81Aa1, pET28a
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
							
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 28th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR: </a> BL21-pET28a-BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> BL21-pET28a-BmK IT1 colony PCR
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	SDS-PAGE</a> 
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture for protein production: </a> BL21-pET28a-Xpp81Aa1, BL21-pET28a-BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/large-scale-protein-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Large scale protein extraction: </a>  BL21-pET28a-Cyt2Ba #2  
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
								
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 July 31st (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating: </a> BL21-pET28a-BmK
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture for protein production:</a> BL21-empty  
						</p>
					
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao 
						</p>
						</section>			
						
						<section id='s3'>
						<div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
							<span className='text-gray-800 font-bold'></span>
						</div>
						<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							August
						</h2>	

						<p className='text-xl mt-6 mb-2 font-bold'> 
						2024 August 1st (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating:</a>  BL21-empty 
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture for protein production:</a>  BL21-pET28a-Cyt2Ba 
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
                            src={labnotes104}
                            alt='softwarePic'
                            className='w-2/5 h-auto ml-5'
                        />
						<div class="container p-2 w-1/2">
  {/* Table */}
  <table class="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
    <thead class='bg-gray-400'>
      <tr>
        <th class="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
        <th class="border border-gray-300 px-2 text-right py-1">8/1/2024</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
        <td class="border border-gray-300 px-2 py-1">BL21-empty</td>
      </tr>
      <tr>
        <td class="border border-gray-300 bg-gray-100 px-2 py-1">Inoculation volume (mL)</td>
        <td class="border border-gray-300 px-2 py-1">0.1</td>
      </tr>
      <tr>
        <td class="border border-gray-300 bg-gray-100 px-2 py-1">Dilution factor N (10^(-N))</td>
        <td class="border border-gray-300 px-2 py-1">5</td>
      </tr>
      <tr>
        <td class="border border-gray-300 bg-gray-100 px-2 py-1">Colony number</td>
        <td class="border border-gray-300 px-2 py-1">1</td>
      </tr>
      <tr>
        <td class="border border-gray-300 bg-gray-100 px-2 py-1">Bacteria concentration (CFU/mL)</td>
        <td class="border border-gray-300 px-2 py-1">1.00E+06</td>
      </tr>
    </tbody>
  </table>
</div>

						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng 
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
						<p className='text-lg ml-5'>
						Audrey Fang
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao 
						</p>
									
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 2nd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR:</a> Xpp81Aa1
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
                            src={labnotes105}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5'>
						The colony PCR of a total of ten samples was carried out. 	
						</p>

						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
									
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 3rd (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating: </a> BL21-pET28a-Cyt2Ba #1, BL21-Empty 
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR: </a>  Vip3Aa fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis: </a> Vip3Aa fragment PCR
  
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/trial-scale-extraction-celllyticb-docx.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Trial scale protein extractio: </a>  BL21-pET28a-Cyt2Ba, BL21-empty, BL21-pET28a-BmK
						</p>
						
						<p className='text-lg font-bold'>
							Results
						</p>	
						<img
                            src={labnotes107}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />

						<p className='text-lg ml-5'>
						-	Gel electrophoresis showed no bands
						</p>
						<img
                            src={labnotes108}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">8/3/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #1</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">5</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">94</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">9.40E+07</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">8/3/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-empty</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">5</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">40</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">4.00E+07</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							
						<p className='text-lg font-bold'>
							Notes
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <tbody>
									<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Temperature</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">Time</td>
											<td className="border border-gray-300 px-2 border-b-0 text-right py-1"></td>
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 ">98°C</td>
                                            <td className="border border-gray-300 px-2 py-1">10 sec</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1">68°C</td>
                                            <td className="border border-gray-300 px-2 py-1">30 sec</td>
											
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1">72°C</td>
                                            <td className="border border-gray-300 px-2 py-1">1 min</td>
											<td className="border border-gray-300 px-2 border-t-0 py-1">repeat 30 cycles</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng 
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao 
						</p>
									
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 4th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-using-q5-high-fidelity-dna-polymerase.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR using Q5 DNA polymerase: </a> Vip3Aa, Cry2Aa, BBa_K4955002 fragment
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating: </a>  BL21-pET28a-BmK IT1 #2
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	SDS-PAGE</a>  BL21-pET28a-BmK, BL21-pET28a-Cyt2Ba, BL21-empty
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	DNA assembly: </a> pET28a + Vip3Aa
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a </a>
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/large-scale-protein-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Large scale protein extraction: </a> BL21-empty, BL21-pET28a-Cyt2Ba
						</p>
												
						<p className='text-lg font-bold'>
							Results
						</p>	
						<img
                            src={labnotes106}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						
						<img
							src={labnotes61}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao 
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 6th (CST)
						</p>
						
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Liquid bacterial culture: </a> BL21-pET28a-Xpp81Aa1 #1, BL21-pET28a-Cyt2Ba #1

						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation </a> pET28a-Vip3Aa into DH5α cells  
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Florence Wu 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 7th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a: </a> 

						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-using-q5-high-fidelity-dna-polymerase.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Overlap extension PCR using Q5 DNA polymerase </a> Cry2Aa fragment
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
                            src={labnotes109}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<p className='text-lg font-bold'>
							Notes
						</p>
						<p className='text-lg ml-5'>
						The 14th and 15th lanes on the gel are undigested and digested pET28a.
						</p>
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						
						<br>
						</br>
						
						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 9th (CST)
						</p>
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Restriction enzyme digestion of pET28a: </a>

						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<img
                            src={labnotes110}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						
						<br>
						</br>
						
						<p className='text-xl mt-2 mb-2 font-bold'>  
						2024 August 10th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• DNA assembly: 
						</a> pET28a + Vip3Aa
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Transformation: 
						</a> pET28a-Vip3Aa into DH5α cells
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Serial dilution: 
						</a> BL21-pET28a-Xpp81Aa1, BL21-pET28a-Cyt2Ba
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Liquid bacterial culture: 
						</a> DH5α-pET28a-Vip3Aa
						</p>

						<p className='text-lg ml-5'>
						• Mutagenesis: Cyt2Ba mutant fragment
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Bradford protein assay: 
						</a> BL21-pET28a-Cyt2Ba, BL21-pET28a-BmK
						</p>
						<p className='text-lg font-bold'>
						Results
						</p>
						<div className="container p-2 w-1/2">
    {/* Table */}
    <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
        <thead className='bg-gray-400'>
            <tr>
                <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                <th className="border border-gray-300 px-2 text-right py-1">8/10/2024</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Xpp81Aa1 #1</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Inoculation volume (mL)</td>
                <td className="border border-gray-300 px-2 py-1">0.1</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">dilution factor N (10^(-N))</td>
                <td className="border border-gray-300 px-2 py-1">6</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Colony number</td>
                <td className="border border-gray-300 px-2 py-1">54</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Bacteria concentration (CFU/mL)</td>
                <td className="border border-gray-300 px-2 py-1">5.40E+08</td>
            </tr>
        </tbody>
    </table>
</div>
<div className="container p-2 w-1/2">
    {/* Table */}
    <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
        <thead className='bg-gray-400'>
            <tr>
                <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                <th className="border border-gray-300 px-2 text-right py-1">8/10/2024</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #1</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Inoculation volume (mL)</td>
                <td className="border border-gray-300 px-2 py-1">0.1</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">dilution factor N (10^(-N))</td>
                <td className="border border-gray-300 px-2 py-1">5</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Colony number</td>
                <td className="border border-gray-300 px-2 py-1">15</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Bacteria concentration (CFU/mL)</td>
                <td className="border border-gray-300 px-2 py-1">1.50E+07</td>
            </tr>
        </tbody>
    </table>
</div>

						<p className='text-lg font-bold'>
						Participants
						</p>

						<p className='text-lg ml-5'>
						Abner Tseng
						</p>

						<p className='text-lg ml-5'>
						Katie Liu
						</p>

						<p className='text-lg ml-5'>
						Abby Hung
						</p>
												
						<br>
						</br>
						
						
						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 11th (CST)
						</p>

						
						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Colony PCR: 
						</a> DH5α-pET28a-BBa_K4955002, DH5α-pET28a-Vip3Aa
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Gel electrophoresis: 
						</a> DH5α-pET28a-BBa_K4955002 colony PCR, DH5α-pET28a-Vip3Aa colony PCR
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Overlap extension PCR: 
						</a> Xpp81Aa1 (no stop codon) fragment
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Bradford protein assay: 
						</a> BL21-pET28a-Cyt2Ba, BL21 empty
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
							src={labnotes63}
							alt='softwarePic'
							className='w-3/4 h-auto'
						/>
						<p className='text-lg font-bold'>
						Participants
						</p>

						<p className='text-lg ml-5'>
						Abner Tseng
						</p>

						<p className='text-lg ml-5'>
						Eugene Lee
						</p>

						<p className='text-lg ml-5'>
						Megan Chiao
						</p>

						
						<br>
						</br>
						
						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 12th (CST)
						</p>
						
						<p className='text-lg font-bold'>
							Methods
						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Transformation: </a> pET28a-Cyt2Ba mutant into DH5α cells

						</p>
						<p className='text-lg ml-5'>
                        <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Gel electrophoresis </a> Xpp81Aa1 (no stop codon) fragment PCR 
						</p>
						<p className='text-lg font-bold'>
							Results
						</p>
						<p className='text-lg ml-5'>
						-	Gel electrophoresis showed no bands
						</p>
						
						<p className='text-lg font-bold'>
							Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<p className='text-lg ml-5'>
						Florence Wu
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting 
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						
						<br>
						</br>
						
						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 13th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pcr-using-q5-high-fidelity-dna-polymerase.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Overlap extension PCR using Q5 DNA polymerase: 
						</a> Xpp81Aa1 fragment
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• PCR isolation using QIAquick PCR purification kit: 
						</a> Vip3Aa, BBa_K4955002
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Gel electrophoresis: 
						</a> Xpp81Aa1 fragment PCR
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>

						<p className='text-lg ml-5'>
						- Gel electrophoresis showed no bands
						</p>

						<p className='text-lg font-bold'>
						Notes
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>

						<p className='text-lg ml-5'>
						Abby Hung
						</p>

						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 14th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Gel electrophoresis: 
						</a> Xpp81Aa1 fragment PCR
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/inclusion-bodies-extraction-docx.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Inclusion bodies extraction: 
						</a> BL21-pET28a-Cyt2Ba, BL21 empty
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>

						<p className='text-lg ml-5'>
						- Gel electrophoresis showed no bands
						</p>

						<p className='text-lg font-bold'>
						Notes
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>

						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 15th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Bradford protein assay: 
						</a> BL21 empty, BL21-pET28a-Cyt2Ba
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>

						<p className='text-lg font-bold'>
						Notes
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>

						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng 
						</p>

						<br>
						</br>

						
						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 16th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Bradford protein assay: </a> BL21 empty, BL21-pET28a-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• PCR isolation using QIAquick PCR purification kit:</a> pET28a and Cyt2Ba
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Morris Yang 
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng 
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 17th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Restriction enzyme digestion of pET28a </a>
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/pcr-using-q5-high-fidelity-dna-polymerase.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Overlap extension PCR using Q5 DNA polymerase:</a> Xpp81Aa1 (no stop codon) fragment, Cyt2Ba mutant fragment
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Gel electrophoresis</a> Xpp81Aa1(no stop codon) fragment PCR, pET28a digestion
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Bradford protein assay</a> 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/inclusion-bodies-extraction-docx.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Inclusion body extraction </a> 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• DNA assembly:</a> pET28a + Vip3Aa
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Serial dilution</a> BL21-pET28a-Xpp81Aa #1
						</p>
						

						<p className='text-lg font-bold'>
						Results
						</p>
						<p className='text-lg ml-5'>
						-	Gel electrophoresis: pET28a digestion showed no bands, Xpp81Aa1 (no stop codon) fragment PCR was correct and cut
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">8/17/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">pET28a-Xpp81Aa1#1</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">45</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">4.50E+08</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Dora Shen
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 18th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• SDS PAGE: </a> BL21-pET28a-BmK, BL21-pET28a-Cyt2Ba, BL21-empty
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR: </a> BL21-pET28a-Vip3Aa, BL21-pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Gel electrophoresis:</a> Vip3Aa colony PCR
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Overlap extension PCR: </a> Xpp81Aa1 (no stop codon) fragment

						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/large-scale-protein-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Large-scale protein extraction: </a> BL21-pET28a-Xpp81Aa1, BL21-pET28a-Cyt2Ba ( 37°C, 4hr IPTG induction) 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a> pET28a-Cyt2Ba mutant into DH5α cells 
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Protein Extraction 8/18</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Concentration (μg/μL)</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Xpp81Aa1 (8/10)</td>
                                            <td className="border border-gray-300 px-2 py-1">23828</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Xpp81Aa1 (8/17)</td>
                                            <td className="border border-gray-300 px-2 py-1">5525</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Cyt2Ba( 4hr induction)</td>
                                            <td className="border border-gray-300 px-2 py-1">747.4</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Xpp81Aa1 non-induction</td>
                                            <td className="border border-gray-300 px-2 py-1">4309 </td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Xpp81Aa(8/10)-S1</td>
                                            <td className="border border-gray-300 px-2 py-1">637.6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Xpp81Aa(8/17)-S1</td>
                                            <td className="border border-gray-300 px-2 py-1">637.6 </td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							<img
							src={labnotes64}
							alt='softwarePic'
							className='w-1/2 h-auto'
						/>
						<p className='text-lg ml-5'>
						-	Gel showed no bands 
						</p>
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 19th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a> pET28a-Cyt2Ba mutant into DH5α cells, pET28a into BL21 cells
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes65}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />
						<img
                            src={labnotes66}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 20th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/qiaprep-spin-miniprep-kit-dna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  DNA extraction:</a> pET28a-Vip3Aa
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Serial dilution and Plating:</a>  BL21-pET28a-Cyt2Ba #1
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">DNA Extraction 8/18</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Concentration (ng/μL)</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Vip3Aa</td>
                                            <td className="border border-gray-300 px-2 py-1">21</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">8/20/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">pET28a-Xpp81Aa1#1</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">34</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">3.40E+07</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Morris Yang 
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 21st (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/qiaprep-spin-miniprep-kit-dna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  DNA extraction:</a> pET28a 
						</p>
						<p className='text-lg font-bold'>
						Results
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">DNA Extraction 8/18</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Concentration (ng/μL)</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a</td>
                                            <td className="border border-gray-300 px-2 py-1">502</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<p className='text-lg font-bold'>
						Notes
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Morris Yang 
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 22nd (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a> pET28a into DH5α cells
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Serial dilution and Plating: </a> pET28a-Xpp81A1 #1 (37°C, 4hr IPTG induction)

						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes67}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />

<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">8/20/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">pET28a-Xpp81Aa1#1</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">24</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">2.40E+08</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 23rd (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Restriction enzyme digestion of pET28a</a> 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture:</a>BL21-pET28a-Cyt2Ba 
						</p>
						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes111}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<p className='text-lg ml-5'>
						-	The first and second lanes are undigested and digested pET28a.

						</p>
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 24th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a>  pET28a into BL21 cells
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Restriction enzyme digestion of pET28a</a> 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Gel electrophoresis:</a> pET28a digestion
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes114}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />

						<p className='text-lg ml-5'>
						-	No bands except DNA ladder 
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng 
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 25th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR:</a> BL21-pET28a
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture:</a>  pET28a-BmK
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Serial dilution and Plating: </a> BL21-pET28a-BmK
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Gel electrophoresis: </a> digested pET28a, pET28a colony PCR 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	SDS-PAGE:</a>BL21-pET28a-Xpp81Aa1  
						</p>
						<p className='text-lg ml-8'>
						Condition: no induction vs. 1mM IPTG induction for 20°C overnight, 37°C 4hr, 37°C overnight
						</p>
						<p className='text-lg ml-8'>
						Basic part: pET28a-Xpp81Aa1, pET28a-Cyt2Ba
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<p className='text-lg ml-5'>
						-	All pET28a digests and colony PCRs had no successful bands
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Colonies</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">BmK IT1 10^(-4)</td>
                                            <td className="border border-gray-300 px-2 py-1">55</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">BmK IT1 10^(-5)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">BmK IT1 10^(-6)</td>
                                            <td className="border border-gray-300 px-2 py-1">133</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">BmK IT1 10^(-7)</td>
                                            <td className="border border-gray-300 px-2 py-1">0 </td>
                                           
                                        </tr>
                                    
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
    {/* Table */}
    <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
        <thead className='bg-gray-400'>
            <tr>
                <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                <th className="border border-gray-300 px-2 text-right py-1">8/25/2024</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                <td className="border border-gray-300 px-2 py-1">BL21-pET28a-BmK</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Inoculation volume (mL)</td>
                <td className="border border-gray-300 px-2 py-1">0.1</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">dilution factor N (10^(-N))</td>
                <td className="border border-gray-300 px-2 py-1">6</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Colony number</td>
                <td className="border border-gray-300 px-2 py-1">133</td>
            </tr>
            <tr>
                <td className="border border-gray-300 bg-gray-100 px-2 py-1">Bacteria concentration (CFU/mL)</td>
                <td className="border border-gray-300 px-2 py-1">1.33E+09</td>
            </tr>
        </tbody>
    </table>
</div>

							
						<p className='text-lg font-bold'>
						Notes
						</p>
						<img
                            src={labnotes68}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Chelsea Lin
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 27th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/qiaprep-spin-miniprep-kit-dna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	QIAprep Spin Miniprep Kit DNA Extraction: </a> pET28a-BBa_K4955002
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>

						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">DNA Extraction 8/27</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Concentration (ng/μL)</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Chromosome Free</td>
                                            <td className="border border-gray-300 px-2 py-1">7</td>
                                           
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
							<img
                            src={labnotes69}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 28th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a> BL21-pET28a (200 ng/μL), BL21-pET28a (400 ng/μL), BL21-pET28a-BBa_K4955002 
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>


						<img
                            src={labnotes70}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<p className='text-lg font-bold'>
						Notes
						</p>
						<img
                            src={labnotes71}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung 
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao 
						</p>

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 29th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR </a> & <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							gel electrophoresis: </a>BL21-pET28a (200ng/μL), BL21-pET28a(400ng/μL), BL21-pET28a-BBa_K4955002,
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture: </a>Cyt2Ba#1,#2,#3
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>

						<p className='text-lg ml-5'>
						-	BL21-pET28a (200μg/μL), BL21-pET28a(400μg/μL), BL21-pET28a-BBa_K4955002_k4955002 gels were all smeared

						</p>
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 30th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture for protein production:</a> 

						</p>
						<p className='text-lg ml-8'> 
						Condition: no induction vs. 1mM IPTG induction for 20°C overnight
						</p>
						<p className='text-lg ml-8'>
						Basic part: pET28a-Cyt2Ba #2, pET28a-BmK IT1 #2
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a> DH5α-pETDuet-Cyt2Ba-p20-Xpp81A1

						</p>

						<p className='text-lg font-bold'>
						Results
						</p>

   						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <tbody>
                                    <tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-14 py-1">Sample</td>
                                            <td className="border border-gray-300 text-right px-8 py-1">Condition</td>
                                            <td className="border border-gray-300 px-2 text-right py-1"></td>
											<td className="border border-gray-300 px-2 text-right py-1">Con(µg/mL)</td>
											<td className="border border-gray-300 px-2 text-right py-1">dilution factor</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1 ">pET28a-Cyt2Ba#2</td>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1">non-induction</td>
											<td className="border border-gray-300 px-2 py-1 ">Lysate</td>
                                            <td className="border border-gray-300 px-2 py-1">379.5</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1 ">supernatant</td>
                                            <td className="border border-gray-300 px-2 py-1">156.8</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
										
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1 ">pET28a-Cyt2Ba#2</td>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1">1mM(IPTG)</td>
											<td className="border border-gray-300 px-2 py-1 ">Lysate</td>
                                            <td className="border border-gray-300 px-2 py-1">383.9</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1 ">supernatant</td>
                                            <td className="border border-gray-300 px-2 py-1">121.9</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
                                       
                                        </tr><tr>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1 ">pET28a-BmK#2</td>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1">non-induction</td>
											<td className="border border-gray-300 px-2 py-1 ">Lysate</td>
                                            <td className="border border-gray-300 px-2 py-1">330.9</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1 ">supernatant</td>
                                            <td className="border border-gray-300 px-2 py-1">154.6</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
                                       
                                        </tr><tr>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1 ">pET28a-BmK#2</td>
                                            <td className="border border-gray-300 px-2 border-b-0 py-1">1mM(IPTG)</td>
											<td className="border border-gray-300 px-2 py-1 ">Lysate</td>
                                            <td className="border border-gray-300 px-2 py-1">312.8</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
                                            <td className="border border-gray-300 border-t-0 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1 ">supernatant</td>
                                            <td className="border border-gray-300 px-2 py-1">187.2</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
                                       
                                        </tr>
										
                                    </tbody>
                                </table>
                            </div>



<img
                            src={labnotes72}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />
					

						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 August 31st (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Serial dilution and Plating:</a> BL21-pET28a-BmK IT1 #2, BL21-pET28a-Cyt2Ba #2
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a> pET28a-Cyt2Ba into BL21 cells 
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes73}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Colonies </td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">BmK IT1 10^(-4)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">BmK IT1 10^(-5)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">BmK IT1 10^(-6)</td>
                                            <td className="border border-gray-300 px-2 py-1">66</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">BmK IT1 10^(-7)</td>
                                            <td className="border border-gray-300 px-2 py-1">10</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">8/31/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #2</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">7</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">10</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">1.0E+09</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

							
						
						<img
                            src={labnotes74}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Colonies </td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Cyt2Ba 10^(-4)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Cyt2Ba 10^(-5)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Cyt2Ba 10^(-6)</td>
                                            <td className="border border-gray-300 px-2 py-1">135</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Cyt2Ba 10^(-7)</td>
                                            <td className="border border-gray-300 px-2 py-1">12</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">8/31/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #2</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">7</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">12</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">1.2 E+09</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						
						<img
                            src={labnotes75}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />


						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao 
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen 
						</p>
						</section>

						<section id='s4'>
						<div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
							<span className='text-gray-800 font-bold'></span>
						</div>
						<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							September
						</h2>	

						<p className='text-xl mt-6 mb-2 font-bold'> 
						2024 September 1st (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  SDS-PAGE:</a>  BL21-pET28a-Cyt2Ba, BL21-pET28a-BmK,  
						</p>
						<p className='text-lg ml-8'>
						Condition: no induction vs. 1mM IPTG induction for 37°C 4 hours
						</p>
						<p className='text-lg ml-8'>
						S: Supernatant, L: Lysate
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR:</a> pETDuet-Cyt2Ba-p20-Xpp81Aa (50ng/uL)

						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Serial dilution and Plating:</a> BL21-pET28a-BmK#2 ( 37°C, 4hrs IPTG induction)
						</p>
						<p className='text-lg ml-5'>
							•  Larvicidal assay result collection 
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes76}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">9/1/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-BmK IT1 #2</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">68</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">6.8E+08</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
						<img
                            src={labnotes77}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<img
                            src={labnotes78}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />

				<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <tbody>
                                    <tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">8/25-9/1 larvicidal results</td>
                                            <td className="border border-gray-300 px-2 text-right py-1"></td>
                                            <td className="border border-gray-300 px-2 text-right py-1">R1</td>
											<td className="border border-gray-300 px-2 text-right py-1">R2</td>
											<td className="border border-gray-300 px-2 text-right py-1">R3</td>
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">9</td>
											<td className="border border-gray-300 px-2 py-1">9</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">7</td>
											<td className="border border-gray-300 px-2 py-1">4</td>
											<td className="border border-gray-300 px-2 py-1">9</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">6</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">Cyt2Ba</td>
                                            <td className="border border-gray-300 px-2 py-1">104</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">108</td>
											<td className="border border-gray-300 px-2 py-1">4</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">4</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">Xpp81Aa 37C overnight</td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">108</td>
											<td className="border border-gray-300 px-2 py-1">9</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">9</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">9</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">6</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">Xpp81Aa 20C overnight</td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">108</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
											<td className="border border-gray-300 px-2 py-1">10</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">3</td>
											<td className="border border-gray-300 px-2 py-1">7</td>
											<td className="border border-gray-300 px-2 py-1">3</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">Xpp81Aa 37C 4hr</td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">300mg</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">150mg</td>
											<td className="border border-gray-300 px-2 py-1">3</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">60mg</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">BL21-empty</td>
                                            <td className="border border-gray-300 px-2 py-1">30mg</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">300mg</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">150mg</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">60mg</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">Cyt2Ba</td>
                                            <td className="border border-gray-300 px-2 py-1">30mg</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1"></td>
                                            <td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1">water only</td>
                                            <td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>


						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Abner Tseng 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 2nd (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR:</a> BL21-pET28a-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Restriction enzyme Digestion of pET28a</a> 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  DNA Assembly: </a>  pET28a + BmK IT1 (no stop codon) 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Overlap extension PCR: </a> Vip3Aa fragment
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a>  DH5α-pET28a-BmK IT1 (no stop codon), DH5α-pET28a-Cyt2Ba mutant, pETDuet-Cyt2Ba-P20-Xpp81Aa1
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes79}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />
						<img
                            src={labnotes80}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<img
                            src={labnotes81}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<img
                            src={labnotes119}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting 
						</p>
						<p className='text-lg ml-5'>
						Katie Liu 
						</p>
						<p className='text-lg ml-5'>
						Eugene Lee
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 3rd (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Serial dilution and Plating:</a> BL21-pET28a-Cyt2Ba #2 (1 mM IPTG induction for 20°C Overnight) 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a> DH5α-pET28a-Cyt2Ba
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes82}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />
						<img
                            src={labnotes83}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />


<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Colonies </td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Cyt2Ba 20°C O/N 10^(-4)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">10^(-5)</td>
                                            <td className="border border-gray-300 px-2 py-1">60</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">10^(-6)</td>
                                            <td className="border border-gray-300 px-2 py-1">31</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">10^(-7)</td>
                                            <td className="border border-gray-300 px-2 py-1">0</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">9/3/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #2</td>
                                        
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">31</td>
                                            
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">3.1E+08</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

						
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 5th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR: </a> pETDuet- Cyt2Ba-p20-Xpp81Aa, pET28a-BmK IT1 (no stop codon)
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  DNA Assembly:</a> pET28a + BmK IT1 (no stop codon), Vip3Aa fragment (from 9/2)
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes84}
                            alt='softwarePic'
                            className='w-3/5 h-auto'
                        />
						<p className='text-lg ml-5'>
						-	pET28a + BmK IT1 (no stop codon) bands were correct
						</p>
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 6th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a> pET28a-Vip3Aa into DH5ɑ
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/large-scale-protein-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Large scale protein extraction:</a> BL21-pET28a-Cyt2Ba #2 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Gel electrophoresis:</a> Vip3Aa colony PCR
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>

						<img
                            src={labnotes85}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						<p className='text-lg ml-5'>
						Megan Chiao
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 7th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Colony PCR:</a> Vip3Aa
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Bradford protein assay:</a> BL21-pET28a-Cyt2Ba #2, BL21-pET28-BmK IT1 #2
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Serial dilution and plating:</a> BL21-pET28a-Cyt2Ba #2 ( 37°C, 4hr, 1mM IPTG induction) 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/rna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  RNA extraction </a> and <a href="https://static.igem.wiki/teams/5066/wetlab/reverse-transcription-cdna-synthesis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							reverse transcription:</a>Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for 20°C overnight) compare to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 24 hr post-exposure. All samples were conducted in triplicate.
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						
						<img
                            src={labnotes87}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<img
                            src={labnotes86}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />

						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Colonies </td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Cyt2Ba  37°C 4hr 10^(-4)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">10^(-5)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">10^(-6)</td>
                                            <td className="border border-gray-300 px-2 py-1">32</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">9/7/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-Cyt2Ba #2</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">6</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">32</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">3.2E+08</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 8th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

					
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•	Serial dilution and plating:</a> BL21-pET28a-BmK#2 (20°C, 1mM IPTG induction overnight)
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  SDS-PAGE:</a> pET28a-BmK IT1 (Gel1), pET28a-Cyt2Ba (Gel2)
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>			

						<img
                            src={labnotes88}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
												<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Colonies </td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Cyt2Ba  37°C 4hr 10^(-5)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">10^(-6)</td>
                                            <td className="border border-gray-300 px-2 py-1">100</td>
                                           
                                        </tr>
										<tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">10^(-7)</td>
                                            <td className="border border-gray-300 px-2 py-1">60</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead className='bg-gray-400'>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Serial Dilution</th>
                                            <th className="border border-gray-300 px-2 text-right py-1">9/8/2024</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Clone</td>
                                            <td className="border border-gray-300 px-2 py-1">BL21-pET28a-BmK</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">Inoculation volume (mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">0.1</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">dilution factor N ( 10^(-N) )</td>
                                            <td className="border border-gray-300 px-2 py-1">7</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Colony number</td>
                                            <td className="border border-gray-300 px-2 py-1">60</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 bg-gray-100  px-2 py-1">Bacteria concentration (CFU/mL)</td>
                                            <td className="border border-gray-300 px-2 py-1">6.0E+09</td>
                                           
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
							<img
                            src={labnotes89}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
					
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 9th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a> BL21-pET28a-Cyt2Ba mutant 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/rna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  RNA extraction </a> and <a href="https://static.igem.wiki/teams/5066/wetlab/reverse-transcription-cdna-synthesis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							reverse transcription: </a> Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for 20°C overnight) compare to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 48 hr post-exposure. All samples were conducted in triplicate.

						</p>
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>

						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 10th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR:</a> DH5α-pET28a-Cyt2Ba mutant
							</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes90}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>


						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 11th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  DNA assembly:</a> pET28a + Xpp81Aa1-Cyt2Ba, pET28a + p20-Cyt2Ba
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a> DH5ɑ-pET28a-Xpp81Aa1-Cyt2Ba, DH5ɑ-pET28a-p20-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/real-time-pcr-qpcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Real-time PCR:</a> Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for 20°C overnight) compared to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 24 hr post-exposure. 
						</p>
						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes112}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
							Katie Liu
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 12th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Gel electrophoresis: </a> eGFP fragment PCR
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation：</a> BL21-pET28a-BmK IT1 (no stop codon) #1 & #4, DH5α-pET28a-eGFP
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR:</a> DH5α-pET28a-P20-Cyt2Ba, DH5α-pET28a-Xpp81Aa1-Cyt2Ba
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/real-time-pcr-qpcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Real-time PCR: </a> Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for 20°C overnight) compared to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 48 hr post-exposure. 
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes113}
                            alt='softwarePic'
                            className='w-2/5 h-auto'
                        />
						<img
                            src={labnotes91}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />

						<p className='text-lg font-bold'>
						Notes
						</p>
						<p className='text-lg ml-5'>
						Gel run 33 mins 
						</p>
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 13th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Gel electrophoresis: </a> BmK-Cyt2Ba fragment PCR, Xpp81Aa1 (no stop codon)  fragment PCR, Xpp81Aa1-BmK IT1  fragment PCR, Cyt2Ba (no stop codon)  fragment PCR
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  DNA Assembly: </a> pET28a + BmK-Cyt2Ba,  pET28a + Xpp81Aa1 (no stop codon),  pET28a + Xpp81Aa1-BmK,  pET28a + Cyt2Ba (no stop codon) 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a> DH5α-pET28a-BmK-Cyt2Ba, DH5α-pET28a-Xpp81Aa1 (no stop codon), DH5α-pET28a-Xpp81Aa1-BmK, DH5α-pET28a-Cyt2Ba (no stop codon) 
						</p>
						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes115}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 14th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Colony PCR: </a> pET28a-Xpp81Aa1 (no stop codon), pET28a-Cyt2Ba (no stop codon), pET28a-BmK-Xpp81Aa1, pET28a-Cyt2Ba-BmK
							</p>
						<p className='text-lg ml-5'>
						•  BL21-pET28a-Cyt2Ba-Chromosome free co-transformation by following <a href="https://parts.igem.org/Part:BBa_K4955002" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">iGEM23_Japan-United</a>'s protocol
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes100}
                            alt='softwarePic'
                            className='w-5/6 h-auto'
                        />
						<img
                            src={labnotes116}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<img
                            src={labnotes92}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Lucia Ting
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 21st (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>•  BL21-pET28a-Cyt2Ba-Chromosome free co-transformation by following <a href="https://parts.igem.org/Part:BBa_K4955002" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">iGEM23_Japan-United</a>'s protocol
						</p>
						<p className='text-lg ml-5'>
						•  Larvicidal assay results collection
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes93}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />


<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <tbody>
                                    <tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1"></td>
                                            <td className="border border-gray-300 px-2 text-right py-1"></td>
                                            <td className="border border-gray-300 px-2 text-right py-1">R1</td>
											<td className="border border-gray-300 px-2 text-right py-1">R2</td>
											<td className="border border-gray-300 px-2 text-right py-1">R3</td>
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">108</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">Cyt2Ba 37C 4hr</td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">2</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">108</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">3</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">Xpp81Aa 37C 4hr</td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
											<td className="border border-gray-300 px-2 py-1">5</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">108</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">BmK IT1 37C 4hr</td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">108</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">3</td>
											<td className="border border-gray-300 px-2 py-1">3</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">107</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-2 py-1 border-t-0 border-b-0"></td>
                                            <td className="border border-gray-300 px-2 py-1">106</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1 border-t-0 border-b-0">BL21-empty</td>
                                            <td className="border border-gray-300 px-2 py-1">105</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">0</td>
                                       
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 px-16 py-1">ddH<sub class="text-sm align-text-bottom">2</sub>O</td>
                                            <td className="border border-gray-300 px-2 py-1"></td>
											<td className="border border-gray-300 px-2 py-1">0</td>
											<td className="border border-gray-300 px-2 py-1">1</td>
											<td className="border border-gray-300 px-2 py-1"></td>
                                       
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Katie Liu
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 22nd (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation:</a> BL21-pET28a-Vip3Aa
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid Bacterial culture for plasmid extraction:</a> DH5α-pET28a-Cyt2Ba (no stop codon), DH5α-pET28a-Xpp81Aa1 (no stop codon)
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture for the kinetic characterization of bacteria growing: </a> pET28a-Cyt2Ba, pET28a-BmK IT1 and pET28a-Xpp81Aa1
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<img
                            src={labnotes94}
                            alt='softwarePic'
                            className='w-1/2 h-auto'
                        />
						<img
                            src={labnotes101}
                            alt='softwarePic'
                            className='w-4/5 h-auto ml-5'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Abby Hung
						</p>
						
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 23rd (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/qiaprep-spin-miniprep-kit-dna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Plasmid DNA extraction: </a> pET28a-Cyt2Ba (no stop codon), pET28a-Xpp81Aa1 (no stop codon) 
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a> BL21-pET28a-Cyt2Ba (no stop codon), BL21-pET28a-Xpp81Aa1 (no stop codon)
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid Bacterial Culture:</a> DH5α-pET28a-Xpp81Aa1-BmK, DH5α-pET28a-BmK-Cyt2Ba, BL21-pET28a-BmK IT1 (no stop codon)
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/rna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  RNA extraction</a>  and <a href="https://static.igem.wiki/teams/5066/wetlab/reverse-transcription-cdna-synthesis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							 reverse transcription:</a> Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for 37°C 4 hr) compare to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 24 and 48 hr post-exposure. All samples conducted in triplicate.

						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture for the kinetic characterization of bacteria growing: </a> pET28a-BBa_K4955002 and pET28a-BmK IT1 (no stop codon)
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Plasmid DNA Extraction 9/23</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Concentration (ng/μL)</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-Cyt2ba (no stop codon)</td>
                                            <td className="border border-gray-300 px-2 py-1">48</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-Xpp81Aa1 (no stop codon)</td>
                                            <td className="border border-gray-300 px-2 py-1">54</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<img
                            src={labnotes95}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<p className='ml-5 text-lg'>
						•   RNA concentration and sample preparation for reverse transcription:
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <tbody>
                                    <tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">37C 4hr IPTG induction</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">RNA (ug/uL)</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">2ug</td>
											<td className="border border-gray-300 px-2 text-right py-1">water (-gDNA wiper)</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba 24 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1207</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.7</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.3</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba 24 hr 2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">880</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">2.3</td>
											<td className="border border-gray-300 px-2 text-right py-1">9.7</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba 24 hr 3</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">625.6</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">3.2</td>
											<td className="border border-gray-300 px-2 text-right py-1">8.8</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba 24 hr 4</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">964.8</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">2.1</td>
											<td className="border border-gray-300 px-2 text-right py-1">9.9</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">xpp 24 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1157.6</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.7</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.3</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">xpp 24 hr 2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1379.2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.9</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.1</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">xpp 24 hr 3</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1060.8</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.9</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.1</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">control 24 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">258.4</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">7.7</td>
											<td className="border border-gray-300 px-2 text-right py-1">4.3</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">control 24 hr 2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">501.6</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">4.0</td>
											<td className="border border-gray-300 px-2 text-right py-1">8.0</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">control 24 hr 3</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">337.6</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">5.9</td>
											<td className="border border-gray-300 px-2 text-right py-1">6.1</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">control 24 hr 4</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">456</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">4.4</td>
											<td className="border border-gray-300 px-2 text-right py-1">7.6</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">bmk 24 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">833.6</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">2.4</td>
											<td className="border border-gray-300 px-2 text-right py-1">9.6</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">bmk 24 hr 2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">708</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">2.8</td>
											<td className="border border-gray-300 px-2 text-right py-1">9.2</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">bmk 24 hr 3</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">602.4</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">3.3</td>
											<td className="border border-gray-300 px-2 text-right py-1">8.7</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">bmk 24 hr 4</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">368</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">5.4</td>
											<td className="border border-gray-300 px-2 text-right py-1">6.6</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">control 48 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">700.8</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">2.9</td>
											<td className="border border-gray-300 px-2 text-right py-1">9.1</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">control 48 hr 2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">777.6</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">2.6</td>
											<td className="border border-gray-300 px-2 text-right py-1">9.4</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba 48 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1347.2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.5</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.5</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">xpp 48 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1316</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.5</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.5</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">xpp 48 hr 2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1379.2</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.5</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.5</td>
                                        </tr>
										<tr>
                                            <td className="border border-gray-300 w-1/2 text-left px-2 py-1">bl21 48 hr 1</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1508.8</td>
                                            <td className="border border-gray-300 px-2 text-right py-1">1.3</td>
											<td className="border border-gray-300 px-2 text-right py-1">10.7</td>
                                        </tr>
                                        
                                        
                                    </tbody>
                                </table>
                            </div>
							<img
                            src={labnotes102}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='text-lg ml-5'>
						Carolyn Chen
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 24th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/qiaprep-spin-miniprep-kit-dna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Plasmid DNA extraction: </a> pET28a-Xpp81Aa1-BmK, pET28a-BmK-Cyt2Ba 
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Transformation: </a> BL21-pET28a-Xpp81Aa1-BmK, BL21-pET28a-BmK-Cyt2Ba
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture for protein production: </a> BL21-pET28a-BmK IT1 (no stop codon) for 20°C overnight
							</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial Culture: </a> BL21-pET28a-Cyt2Ba (no stop codon), BL21-pET28a-Xpp81Aa1 (no stop codon)
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/rna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  RNA extraction</a> and <a href="https://static.igem.wiki/teams/5066/wetlab/reverse-transcription-cdna-synthesis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							reverse transcription: </a> Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for  37°C 4 hr) compare to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 48 hr post-exposure. All samples conducted in triplicate.
						</p>

						<p className='text-lg font-bold'>
						Results
						</p>
						<div className="container p-2 w-1/2">
                                {/* Table*/}
                                <table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
                                    <thead>
                                        <tr>
                                            <th className="border border-gray-300 w-1/2 text-left px-2 py-1">Plasmid DNA Extraction 9/24</th>
                                            <th className="border border-gray-300 px-2 text-right py-1"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Sample</td>
                                            <td className="border border-gray-300 px-2 py-1 bg-gray-100">Concentration (ng/μL)</td>
                                       
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-Xpp81Aa1-BmK</td>
                                            <td className="border border-gray-300 px-2 py-1">51</td>
                                           
                                        </tr>
                                        <tr>
                                            <td className="border border-gray-300  bg-gray-100  px-2 py-1">pET28a-BmK-Cyt2Ba </td>
                                            <td className="border border-gray-300 px-2 py-1">54</td>
                                           
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
							<img
                            src={labnotes96}
                            alt='softwarePic'
                            className='w-3/4 h-auto'
                        />
						<p className='ml-5 text-lg'>
						•  	RNA concentration and sample preparation for reverse transcription:
						</p>

						<div className="container p-2 w-full">
						{/* Table */}
						<table className="mini-w-full table-auto border-collapse border border-gray-300 text-sm">
							<tbody>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								37C 4hr IPTG induction
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								RNA (ug/uL)
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">2ug</td>
								<td className="border border-gray-300 px-2 text-right py-1">water</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								control 1
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">794.4</td>
								<td className="border border-gray-300 px-2 text-right py-1">2.5</td>
								<td className="border border-gray-300 px-2 text-right py-1">13.5</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								control 2
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">488</td>
								<td className="border border-gray-300 px-2 text-right py-1">4.1</td>
								<td className="border border-gray-300 px-2 text-right py-1">11.9</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								control 3
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">691.2</td>
								<td className="border border-gray-300 px-2 text-right py-1">2.9</td>
								<td className="border border-gray-300 px-2 text-right py-1">13.1</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								control 4
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">519.2</td>
								<td className="border border-gray-300 px-2 text-right py-1">3.9</td>
								<td className="border border-gray-300 px-2 text-right py-1">12.1</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								Cyt2Ba 37 4hr 1
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">460</td>
								<td className="border border-gray-300 px-2 text-right py-1">4.3</td>
								<td className="border border-gray-300 px-2 text-right py-1">11.7</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								Cyt2Ba 37 4hr 2
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1352</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.5</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.5</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								Cyt2Ba 37 4hr 3
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1492</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.3</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.7</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								Cyt2Ba 37 4hr 4
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1372.8</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.5</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.5</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								Cyt2Ba 37 4hr 5
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1740</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.1</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.9</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bmk 37 4hr 1
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">886.4</td>
								<td className="border border-gray-300 px-2 text-right py-1">2.3</td>
								<td className="border border-gray-300 px-2 text-right py-1">13.7</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bmk 37 4hr 2
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">802.4</td>
								<td className="border border-gray-300 px-2 text-right py-1">2.5</td>
								<td className="border border-gray-300 px-2 text-right py-1">13.5</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bmk 37 4hr 3
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">879.2</td>
								<td className="border border-gray-300 px-2 text-right py-1">2.3</td>
								<td className="border border-gray-300 px-2 text-right py-1">13.7</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bmk 37 4hr 4
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1103.2
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.8</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.2</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bmk 37 4hr 5
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1152</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.7</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.3</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bmk 37 4hr 6
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								424.8
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">4.7</td>
								<td className="border border-gray-300 px-2 text-right py-1">11.3</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bl21 37 ov 1
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								860.8
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">2.3</td>
								<td className="border border-gray-300 px-2 text-right py-1">13.7</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bl21 37 ov 2
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1082.4
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.8</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.2</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bl21 37 ov 3
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1053.6
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.9</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.1</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bl21 37 ov 4
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1017.6
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">2.0</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.0</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								bl21 37 ov 5
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1265.6
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.6</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.4</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								xpp 37 4hr 1
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1360.8
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.5</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.5</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								xpp 37 4hr 2
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1908</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.0</td>
								<td className="border border-gray-300 px-2 text-right py-1">15.0</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								xpp 37 4hr 3
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1628
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.2</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.8</td>
							</tr>
							<tr>
								<td className="border border-gray-300 w-1/2 text-left px-2 py-1">
								xpp 37 4hr 4
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">
								1369.6
								</td>
								<td className="border border-gray-300 px-2 text-right py-1">1.5</td>
								<td className="border border-gray-300 px-2 text-right py-1">14.5</td>
							</tr>
							</tbody>
						</table>
						</div>
													<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='ml-5 text-lg'>
							Carolyn Chen
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 25th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture for protein production: </a>
							</p>
							<p className='text-lg ml-8'>
							Condition: no induction vs. 1mM IPTG induction for 37°C 4 hours
							</p>
							<p className='text-lg ml-8'>
							Basic part: pET28a-Cyt2Ba (no stop codon), pET28a-Xpp81Aa1 (no stop codon)
							</p>
							<p className='text-lg ml-8'>
							Composite part: pET28a-Xpp81Aa1-BmK, pET28a-BmK-Cyt2Ba
							</p>
							<p className='text-lg ml-8'>
							Condition: no induction vs. 1mM IPTG induction for 20°C overnight pET28a-Cyt2Ba (no stop codon)

							</p>

						
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/real-time-pcr-qpcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Real-time PCR:</a> Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for  37°C 4 hr) compared to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 24 hr post-exposure. 
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='ml-5 text-lg'>
						Abby Hung
						</p>
							
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 26th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture for protein production: </a> 
							</p>
							<p className='ml-6 text-lg'>
							Condition: no induction vs. 1mM IPTG induction for 20°C overnight
							</p>
							<p className='text-lg ml-6'>
							pET28a-Xpp81Aa1 (no stop codon)
							</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/real-time-pcr-qpcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Real-time PCR:</a> Larvae exposed to BL21 <em>E. coli</em> pellet containing pET28a-Cyt2Ba, pET28a-Xpp81Aa1, pET28a-BmK IT1 (1mM IPTG induction for  37°C 4 hr) compared to ddH<sub class="text-sm align-text-bottom">2</sub>O control, with samples collected at 48 hr post-exposure. 
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='ml-5 text-lg'>
						Abby Hung
						</p>
							
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 27th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial Culture: </a> 
							</p>
						<p className='ml-8 text-lg'>
						Primary culture
						</p>
						<p className='ml-8 text-lg'>
						pET28a-BmK IT1 (no stop codon), pET28a-Xpp81Aa1-BmK, pET28a-BmK-Cyt2Ba, pET28a-Vip3Aa
						</p>

						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='ml-5 text-lg'>
							Carolyn Chen
							</p>
							
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 28th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							•  Liquid bacterial culture for protein production: </a>
							</p>
							<p className='text-lg ml-8'>
							Condition: no induction vs. 1mM IPTG induction for 37°C 4 hours
							</p>
							<p className='text-lg ml-8'>
							Basic part: pET28a-BmK IT1 (no stop codon), pET28a-Vip3Aa

							</p>
							<p className='text-lg ml-8'>
							Composite part: pET28a-Xpp81Aa1-BmK, pET28a-BmK-Cyt2Ba
							</p>
							<p className='text-lg ml-8'>
							Condition: no induction vs. 1mM IPTG induction for 20°C overnight

							</p>
							<p className='text-lg ml-8'>
							Composite part: pET28a-Xpp81Aa1-BmK, pET28a-BmK-Cyt2Ba
							</p>
							<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Bradford Protein Assay
						</a>
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/western-blot.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Western Blotting
						</a>
						</p>
						<p className='text-lg ml-5'>
						•	Larvicidal assay results collection
						</p>
						
						<p className='text-lg font-bold'>
						Results
						</p>
						<div className="container p-2 w-full">
  {/* Table */}
  <table className="w-1/2 ml-5 table-auto border-collapse border border-gray-300 text-sm">
    <tbody>
      <tr>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Combination 1</td>
		<td className="border border-gray-300 w-1/2 text-left px-2 py-1"></td>
        <td className="border border-gray-300 px-2 text-right py-1">R1</td>
        <td className="border border-gray-300 px-2 text-right py-1">R2</td>
        <td className="border border-gray-300 px-2 text-right py-1">R3</td>
        <td className="border border-gray-300 px-2 text-right py-1">Mortality</td>
      </tr>
      <tr>
	  	<td className="border border-gray-300 w-1/2 text-left border-b-0 px-2 py-1"></td>
	    <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba+BmK</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">1</td>
        <td className="border border-gray-300 px-2 text-right py-1">6.67</td>
      </tr>
      <tr>
	  <td className="border border-gray-300 w-1/2 text-left border-t-0 border-b-0 px-2 py-1">37C 4hr</td>
	    <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba+Xpp</td>
        <td className="border border-gray-300 px-2 text-right py-1">1</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">6.67</td>
      </tr>
      <tr>
	  <td className="border border-gray-300 w-1/2 text-left border-t-0 border-l-0 px-2 py-1"></td>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">BmK+Xpp</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">5</td>
        <td className="border border-gray-300 px-2 text-right py-1">33.33</td>
      </tr>
    </tbody>
  </table>
  <br>
  </br>
	  <table className="w-1/2 ml-5 table-auto border-collapse border border-gray-300 text-sm">
	  <tbody>
      <tr>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Combination 2</td>
		<td className="border border-gray-300 px-2 text-right py-1"></td>
        <td className="border border-gray-300 px-2 text-right py-1">R1</td>
        <td className="border border-gray-300 px-2 text-right py-1">R2</td>
        <td className="border border-gray-300 px-2 text-right py-1">R3</td>
        <td className="border border-gray-300 px-2 text-right py-1">Mortality</td>
      </tr>
      <tr>
	  <td className="border border-gray-300 px-2 text-right border-b-0 border-t-0 py-1"></td>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba+Xpp</td>
        <td className="border border-gray-300 px-2 text-right py-1">1</td>
        <td className="border border-gray-300 px-2 text-right py-1">3</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">26.67</td>
      </tr>
      <tr>
	  <td className="border border-gray-300 px-2 text-left border-b-0 border-t-0 py-1">20C overnight</td>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Cyt2Ba+BmK</td>
        <td className="border border-gray-300 px-2 text-right py-1">1</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">1</td>
        <td className="border border-gray-300 px-2 text-right py-1">13.33</td>
      </tr>
      <tr>
	  <td className="border border-gray-300 px-2 text-right border-t-0 py-1"></td>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">BmK+Xpp</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">2</td>
        <td className="border border-gray-300 px-2 text-right py-1">13.33</td>
      </tr>
	    
	  </tbody>
  </table>
  <br>
  </br>
	  <table className="w-1/2 ml-5 table-auto border-collapse border border-gray-300 text-sm">
	  <tbody>
	
      <tr>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">Combination 3</td>
		<td className="border border-gray-300 px-2 text-right py-1"></td>
        <td className="border border-gray-300 px-2 text-right py-1">R1</td>
        <td className="border border-gray-300 px-2 text-right py-1">R2</td>
        <td className="border border-gray-300 px-2 text-right py-1">R3</td>
        <td className="border border-gray-300 px-2 text-right py-1">Mortality</td>
      </tr>
      <tr>
	  <td className="border border-gray-300 px-2 border-b-0 text-right py-1"></td>
        <td className="border border-gray-300 w-1/2 text-left px-2 py-1">
          20C overnight
        </td>
        <td className="border border-gray-300 px-2 text-right py-1">1</td>
        <td className="border border-gray-300 px-2 text-right py-1">4</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">33.33</td>
      </tr>
      <tr>
	  <td className="border border-gray-300 px-2 text-left border-t-0 py-1">Cyt2Ba+BmK+Xpp</td>
	  <td className="border border-gray-300 w-1/2 text-left px-2 py-1">37C 4hr</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">5</td>
        <td className="border border-gray-300 px-2 text-right py-1">0</td>
        <td className="border border-gray-300 px-2 text-right py-1">33.33</td>
      </tr>
     
    </tbody>
  </table>
</div>
<p className='ml-5 mt-2 text-lg'>Protein concentration (
<a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">

							Bradford Protein Assay
						</a>)
						</p>
						<img
                            src={labnotes117}
                            alt='softwarePic'
                            className='w-full h-auto ml-5'
                        />


						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='ml-5 text-lg'>
						Megan Chiao
							</p>	
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 29th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/western-blot.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Western Blotting:
						</a> pET28a-Xpp81Aa1, pET28a-Cyt2Ba, and pET28a-BmK IT1 
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/western-blot.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• SDS-PAGE:
						</a> pET28a-Vip3Aa (Large scale)
						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/rna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• RNA extraction
						</a> and <a href="https://static.igem.wiki/teams/5066/wetlab/reverse-transcription-cdna-synthesis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							reverse transcription:
						</a> Larvae exposed to BL21 <em>E. coli</em> pellet, with samples collected at 24 hr post-exposure. All samples were conducted in triplicate.

						</p>
						<img
                            src={labnotes103}
                            alt='softwarePic'
                            className='w-3/4 h-auto ml-5'
                        />
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='ml-5 text-lg'>
						Carolyn Chen
						</p>
						<br>
						</br>

						<p className='text-xl mt-2 mb-2 font-bold'> 
						2024 September 30th (CST)
						</p>

						<p className='text-lg font-bold'>
						Methods
						</p>

						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/real-time-pcr-qpcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Real-time PCR:
						</a> Larvae exposed to BL21 <em>E. coli</em> pellet, with samples collected at 24 hr post-exposure. All samples were conducted in triplicate.

						</p>
						<p className='text-lg ml-5'>
						<a href="https://static.igem.wiki/teams/5066/wetlab/western-blot.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
							• Western Blotting:
						</a> pET28a-BmK
						</p>
						
						<p className='text-lg font-bold'>
						Participants
						</p>
						<p className='ml-5 text-lg'>
						Carolyn Chen
						</p>
					
											

					</section>
				</div>
                </div> 
			</div>
	);
};

export default Notebook;
